import React from 'react';
import { ArrowRight } from 'lucide-react';
interface PurchaseButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
  redirectToCheckout?: boolean;
}
export function PurchaseButton({
  text = 'SI, QUIERO EL MEGAPACK',
  subtext = 'Pago 100% seguro y encriptado',
  className = '',
  fullWidth = false,
  redirectToCheckout = false
}: PurchaseButtonProps) {
  const checkoutUrl = 'https://checkout8.edulabs.online/cart/45605114740933:1';
  const handleClick = () => {
    if (redirectToCheckout) {
      window.location.href = checkoutUrl;
    } else {
      const compraSection = document.getElementById('compra');
      if (compraSection) {
        compraSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  return <div className={`flex flex-col items-center ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-20">
      <button onClick={handleClick} className={`
          group relative flex items-center justify-center gap-2
          bg-emerald-600 hover:bg-emerald-500 text-white 
          font-bold text-lg md:text-xl py-4 px-6 rounded-xl
          shadow-[0_4px_0_rgb(5,150,105)] hover:shadow-[0_2px_0_rgb(5,150,105)] hover:translate-y-[2px]
          transition-all duration-200 ease-in-out
          ${fullWidth ? 'w-full' : 'w-full md:w-auto md:min-w-[280px]'}
        `} data-id="element-21">
        <span data-id="element-22">{text}</span>
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-23" />
      </button>
      {subtext && <p className="mt-3 text-xs text-gray-500 flex items-center gap-1" data-id="element-24">
          <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" data-id="element-25"></span>
          {subtext}
        </p>}
    </div>;
}